module.exports = __webpack_public_path__ + "static/vwtext-regular-eeed1f835c19d68c694e2c6d69a63d47.woff2";